import de from 'vee-validate/dist/locale/de';
import VeeValidate, { Validator } from "vee-validate";
import Vue from "vue";

Vue.use(VeeValidate, { inject: false });

Validator.localize('de', de);